// import "url-polyfill";
import sha256 from "sha256";
import cuid from "cuid";
import uuidv4 from "uuid/v4";
import axios from "axios";
import packageJson from "../../../../package.json";

import { APP_PDC_URL, API_CAPTCHA_SIGNUP_URL, B2B_AUTH_SERVICE_URL, API_PRECOG_URL_V1, APP_NAME } from "../../../config";

import { postRestCall } from "../../services/rest-api-call";
import { displayErrorToast } from "./../overflowNotification";
import { createHttpHeader } from "../../services/http-header";
import UserWriteTypes from "../../../assets/thrift/user-write/user-write_types";

function trimAndLower(id) {
  return id != null ? id.trim().toLowerCase() : id;
}

export const authConstants = {
  LOGIN_START: "LOGIN_START",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",
  LOGIN_RESET: "LOGIN_RESET",

  REFRESH_START: "REFRESH_START",
  REFRESH_SUCCESS: "REFRESH_SUCCESS",
  REFRESH_ERROR: "REFRESH_ERROR",

  VERIFY_TOKEN_START: "VERIFY_TOKEN_START",
  VERIFY_TOKEN_SUCCESS: "VERIFY_TOKEN_SUCCESS",
  VERIFY_TOKEN_ERROR: "VERIFY_TOKEN_ERROR",

  FORGOT_PWD_START: "FORGOT_PWD_START",
  FORGOT_PWD_SUCCESS: "FORGOT_PWD_SUCCESS",
  FORGOT_PWD_ERROR: "FORGOT_PWD_ERROR",
  FORGOT_PWD_RESET: "FORGOT_PWD_RESET",

  RESET_PWD_START: "RESET_PWD_START",
  RESET_PWD_SUCCESS: "RESET_PWD_SUCCESS",
  RESET_PWD_ERROR: "RESET_PWD_ERROR",

  LOGOUT: "LOGOUT"
};

export function refreshTokenByGetParam(refreshToken) {
  return (dispatch) => {
    
    const requestId = cuid();
    const correlationId = uuidv4();

    return new Promise((resolve, reject) => {
      dispatch({
        type: authConstants.REFRESH_START
      });
      const appVersion = packageJson.version;
      let requestTokenApi = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/auth?token=${refreshToken}`,
        headers: {
          "X-App-Name": APP_NAME,
          "X-App-Version": appVersion,
          "X-Request-ID": requestId,
          "X-Correlation-ID": correlationId,
          "X-User-ID": "pippo",          
          "Content-Type": "application/json;charset=utf-8",
          Accept: "application/json;charset=utf-8",
          "Accept-Language": "it-IT"
        }   
      };

      return axios(requestTokenApi)
        .then((result) => {
          dispatch({
            type: authConstants.REFRESH_SUCCESS,
            payload: {
              ...result.data,
              requestId: requestId,
              correlationId: correlationId,
              refreshToken: refreshToken
            }
          });
          resolve();
        }).catch((e) => {
          dispatch({
            type: authConstants.REFRESH_ERROR
          });
          reject();
        });
    });
  };
}

export function unifiedLoginSuccess(
  appName, userId, apiToken, refreshToken, loginMethod, idToken
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: authConstants.LOGIN_START
      });

      const requestId = cuid();
      const correlationId = uuidv4();

      dispatch({
        type: authConstants.LOGIN_SUCCESS,
        payload: {
          loginAuth: {
            securityToken: apiToken,
            id: userId,
            idToken: idToken,
            appName,
            refreshToken: refreshToken,
            correlationId: correlationId,
            requestId: requestId,
            loginMethod: loginMethod 
          }
        }
      });
    });
  };
}

export function login(
  appName, userId, password
) {
  return async(dispatch) => {
    dispatch({
      type: authConstants.LOGIN_START
    });
    userId = trimAndLower(userId);

    let requestNonce = {
      method: "POST",
      url: `${APP_PDC_URL}/auth/getNonce`,
      headers: {
        Authorization: ""
      },
      data: {
        id: userId
      }
    };

    return new Promise((resolve, reject) => {
      return axios(requestNonce)
        .then((result) => {
          let nonce = result.data.nonce;
          let digest = sha256(sha256(userId + password) + nonce);

          let requestDigest = {
            method: "POST",
            url: `${APP_PDC_URL}/auth/verifyDigest`,
            headers: {
              Authorization: ""
            },
            data: {
              digest: digest,
              id: userId
            }
          };
          let apiToken;
          return axios(requestDigest)
            .then(async(resultDigest) => {
              apiToken = resultDigest.data.accessToken;
              const requestId = cuid();
              const correlationId = uuidv4();

              dispatch({
                type: authConstants.LOGIN_SUCCESS,
                payload: {
                  loginAuth: {
                    securityToken: apiToken,
                    id: userId,
                    appName,
                    refreshToken: digest,
                    correlationId: correlationId,
                    requestId: requestId
                  }
                }
              });
            })
            .catch((e) => {
              let code = e.code ? e.code : e.response.data.code ? e.response.data.code : 500;
              let message = e.message ? e.message : e.response.data.message ? e.response.data.message : "Oops, qualcosa è andato storto, riprova.";
              dispatch({
                type: authConstants.LOGIN_ERROR,
                payload:
                  code === "401"
                    ? {
                      code: code,
                      message: ""
                    }
                    : code === "403.1"
                      ? {
                        code: code,
                        message: message,
                        auth: {
                          loginAuth: {
                            securityToken: apiToken,
                            id: userId,
                            appName,
                            refreshToken: digest
                          }
                        }
                      }
                      : { code: code, message: message }
              });
              reject();
            });
        })
        .catch((e) => {
          dispatch({
            type: authConstants.LOGIN_ERROR,
            payload:
              e.response && e.response.data.code === "401"
                ? {
                  code: e.response.data.code,
                  message: ""
                }
                : {
                  code: e.response && e.response.data.code ? e.response.data.code : 500,
                  message: e.response && e.response.data.message ? e.response.data.message : e.message
                }
          });
        });
    });
  };
}

export function resetLogin() {
  return {
    type: authConstants.LOGIN_RESET
  };
}

export function forgotPassword(email, captchaCode) {
  return async(dispatch) => {
    dispatch({
      type: authConstants.FORGOT_PWD_START
    });
    email = trimAndLower(email);

    try {
      const response = await postRestCall(
        `${API_CAPTCHA_SIGNUP_URL}/forgot-password`, null, null, {
          captchaCode,
          userId: email
        }
      );

      dispatch({
        type: authConstants.FORGOT_PWD_SUCCESS,
        payload: response
      });
    } catch (e) {
      dispatch({
        type: authConstants.FORGOT_PWD_ERROR,
        error: e
      });
      displayErrorToast(e.message)(dispatch);
    }
  };
}

export function logout() {
  return async(dispatch) => {
    // let yetTrial = localStorage.getItem("trial-complete");
    let showBanner = localStorage.getItem("showCheckupBanner");
    localStorage.clear();
    localStorage.setItem("showCheckupBanner", showBanner === "true" || showBanner === "null" || showBanner === null);
    sessionStorage.clear();
    window.location.href = global.location.pathname;
    dispatch({
      type: authConstants.LOGIN_RESET
    });
  };
}

export function setAuthToken(token, userId) {
  return {
    type: authConstants.LOGIN_SUCCESS,
    payload: {
      loginAuth: {
        securityToken: token,
        id: userId,
        appName: "DIGITALBOXWEB"
      }
    }
  };
}

export function verifyToken(token) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: authConstants.VERIFY_TOKEN_START
      });
      let request = {
        url: `${B2B_AUTH_SERVICE_URL}/api/v3/verify`,
        method: "POST",
        headers: { ...createHttpHeader(token) },
        data: {
          accessToken: token
        }
      };
      axios(request)
        .then((res) => {
          dispatch({
            type: authConstants.VERIFY_TOKEN_SUCCESS
          });
          resolve(token);
        })
        .catch((err) => {
          dispatch({
            type: authConstants.VERIFY_TOKEN_ERROR
          });
          reject(null);
        });
    });
  };
}

export function getAuthWithAppName(auth, appName = "DIGITALBOXWEB") {
  const loginAuth = auth?.loginAuth ? auth?.loginAuth : auth;

  let authWithAppName = new UserWriteTypes.Auth({
    securityToken: loginAuth.securityToken,
    id: loginAuth.id,
    appName: appName
  });

  authWithAppName.securityToken = loginAuth.accessToken ? loginAuth.accessToken : loginAuth.securityToken;
  authWithAppName.accessToken = loginAuth.securityToken ? loginAuth.securityToken : loginAuth.accessToken;
  authWithAppName.refreshToken = loginAuth.refreshToken;

  return authWithAppName;
}
